import React from "react";
import FamilyTree from "../components/family-tree";

export const Ida = () => {
	return (
		<React.Fragment>
			<h1>Sarah Ida Shreffler Vandenburgh</h1>
			<FamilyTree />
		</React.Fragment>
	);
}